/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Client API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface TemplatePages
 */
export interface TemplatePages {
    /**
     * 
     * @type {string}
     * @memberof TemplatePages
     */
    pageId?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplatePages
     */
    template?: string;
}

export function TemplatePagesFromJSON(json: any): TemplatePages {
    return {
        'pageId': !exists(json, 'pageId') ? undefined : json['pageId'],
        'template': !exists(json, 'template') ? undefined : json['template'],
    };
}

export function TemplatePagesToJSON(value?: TemplatePages): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'pageId': value.pageId,
        'template': value.template,
    };
}


